import React from 'react'
import { NO_RESULT_TEXT } from '../../common'

export const NoMeetingResult: React.FC = () => {
  return <div className='paragraph-medium-extended zocks-text-gray-500 py-1 pe-4 ps-4'>{NO_RESULT_TEXT}</div>
}
